import type {
  InteractiveEmbeddingOptionsState,
  State,
} from "metabase/redux/store";

export const getIsEmbeddingIframe = (_state?: State): boolean => {
  return false;
};

type EmptyObject = Record<string, never>;
export const getEmbedOptions = (
  state: State,
): InteractiveEmbeddingOptionsState | EmptyObject => {
  return state.embed.options;
};
